export default __webpack_public_path__ + "static/media/background.da8c11d9.jpg";